module.exports = __webpack_public_path__ + "static/media/image404.0472a02f.svg";